<template>
  <ui-uploader ref="upload" :type="type" :before-upload="beforeUpload" :show-input-after-success="showInputAfterSuccess" :upload-api="uploadApi" :data="data" :accept="accept" :on-progress="onProgress" :on-format-error="onFormatError" :max-size="maxSize" :max-number="maxNumber" :on-size-exceed="onSizeExceed" :on-number-exceed="onNumberExceed" :on-start="onStart" :on-success="onSuccess" :on-error="onError" :on-remove="onRemove" :on-cancel="onCancel" :on-retry="onRetry" :on-click-file="onClickFile" :on-change="onChange" :on-order-change="onOrderChange" :on-submit="onSubmit" :lang="uploadLang" :auto-orient="autoOrient" :text="text" :width="width" :height="height" :file-list="fileList" :multiple="multiple" :show-list="showList" :support-format="supportFormat" :list-style="listStyle">
    <span slot="text">
      <slot name="text"></slot>
    </span>
    <!-- <ui-spinner v-if="loading && type== 'drag'" center></ui-spinner> -->
  </ui-uploader>
</template>
<script>
import api from "../api/index.js";
import beforeUpload from "../mixin/beforeUpload.js";
import humanFileSize from "../utils/fileSize.js";
import convertOssUrl from "../utils/convertOssUrl.js";
import axios from 'axios'
import config from '../config.js'
const siteConfig = config[process.env.NODE_ENV]
export default {
  name: "upload",

  data() {
    return {
      uploadApi: "",
      data: {},
      headers: api.getHeader().headers,
      fileId: "",
      uploadLang: {
        text: this.$t("uploadBookCover"),
        del: this.$t("delete"),
        retry: this.$t("retry"),
        cancel: this.$t("cancel"),
        ready: this.$t("fileReady")
      },
      loading: false
    };
  },
  props: {
    type: String,
    fileType: {
      type: String,
      default: "uploads"
    },
    listStyle: String,
    supportFormat: {
      type: Array,
      default () {
        return ["gif", "jpg", "jpeg", "png", "webp"];
      }
    },
    maxSize: {
      type: Number,
      default: 15 * 1024 * 1024
    },
    maxNumber: {
      type: Number,
      default: 1
    },
    accept: {
      type: String,
      default: "image/jpeg,image/png,image/jpg,image/gif,image/webp"
    },
    autoOrient: {
      type: Boolean,
      default: true
    },
    text: String,
    width: Number,
    height: Number,
    fileList: Array,
    multiple: Boolean,
    showInputAfterSuccess: Boolean,
    showList: {
      type: Boolean,
      default: true
    }
  },
  mixins: [beforeUpload],
  methods: {
    onProgress({ e, file }) {
      this.$emit("on-progress", { e, file });
    },
    onFormatError({ file }) {
      this.loading = false;
      this.$UiMessage.error(
        this.$t("onlyAcceptFileType", { format: this.supportFormat.join(",") })
      );
    },
    onSizeExceed({ file }) {
      this.loading = false;
      this.$UiMessage.error(
        this.$t("fileMaxSizeExceed", { size: humanFileSize(this.maxSize) })
      );
    },
    onNumberExceed({ file }) {
      this.loading = false;
      this.$UiMessage.error(
        this.$t("fileNumberSizeExceed", { number: this.maxNumber })
      );
    },
    onStart({ file }) {
      this.loading = true;
      this.$emit("on-start", { file });
    },
    onSuccess({ file }) {
      this.loading = false;
      axios.post(`${siteConfig.fileStorageApi}/saveFileToDb`, {
        id: file.id
      }).then(res => {
        this.$emit("on-success", { file });
        this.fileId = res.data.id;
      }).catch(err => {
        console.log(err)
      })
      //  api
      //   .saveFileToDb({
      //     name: file.name,
      //     url: file.ossUrl,
      //     id: file.id
      //   })
      //   .then(res => {
      //     if (this.accept.includes("image")) {
      //       file.url = convertOssUrl({
      //         url: file.ossUrl,
      //         orientation: file.orientation
      //       });
      //     } else if (this.accept.includes("audio")) {
      //       file.url = file.ossUrl;
      //     }

      //
      //
      //   })
      //   .catch(err => {
      //     console.log(err);
      //   });
    },
    onError({ file, err }) {
      console.log(err)
      this.$emit("on-error", { file });
      this.$UiToast.error(this.$t('uploadFailed'))
      this.loading = false;
    },
    onRemove({ file }) {
      this.$emit("on-remove", { file });
    },
    onCancel({ file }) {
      this.loading = false;
    },
    onRetry({ file }) {
      this.loading = false;
    },
    onClickFile({ file }) {},
    onChange({ e }) {
      this.$emit("on-change", { e });
    },
    onOrderChange({ file }) {},
    onSubmit({ file }) {},
    isUploading() {
      return this.$refs["upload"].uploadFiles.some(
        file => file.status == "uploading"
      );
    },
    getFile(status = "finished") {
      return this.$refs["upload"].uploadFiles.filter(
        file => file.status == status
      );
    },
    getFileList() {
      return this.$refs["upload"].uploadFiles;
    },
    getUrl() {
      // let fileList = this.getFile().map(file => file.ossUrl);
      // fileList = fileList.filter(Boolean)
      // return this.fileList.length ? this.fileList.concat(fileList) : fileList
      return this.getFile().map(file => file.ossUrl);
    },
    getId() {
      // let fileList = this.getFile().map(file => file.id);
      // fileList = fileList.filter(Boolean)
      // return this.fileList.length ? this.fileList.concat(fileList) : fileList
      return this.getFile().map(file => file.id);
    },
    click(params) {
      this.$refs["upload"].click(params);
    },
    handleFilesStart(file) {
      this.$refs["upload"].handleFilesStart(file);
    },
    onDrop(e) {
      this.$refs["upload"].onDrop(e);
    }
  }
};

</script>
